import ToolBar from './ToolBar'
import { uploadFileFromContent, getFileContent, criteriaLevelRequest, updateFileFromContent, deleteCrieriaLevel, EditFileFromContent } from '@/network/requests/criteriaLevel'
import CriteriaLevelUtil from './CriteriaLevelUtil'
import { jtCommandRequest } from '@/network/requests/jtCommand'
import Slider from '@/components/slider/main'
import axios from 'axios'

export default {
	components: {
		ToolBar,
		Slider,
	},
	data() {
		this.ruleFileName = 'CriteriaLevel.ini'

		/**
		 * 重名检查
		 * @param {*} rule
		 * @param {*} value
		 * @param {*} callback
		 */
		var checkNameExist = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入配置名称'))
			} else {
				let exist = undefined
				if (this.form.id) {
					exist = this.tableData.find(t => t.name == this.form.name && t._id.$oid != this.form.id)
				} else {
					exist = this.tableData.find(t => t.name == this.form.name)
				}
				if (exist) {
					callback(new Error('配置名称已存在，请更换配置名称。'))
				} else {
					callback()
				}
			}
		}

		return {
			titleDialog: '',
			form: {
				id: '',
				fileId: '',
				name: '',
			},
			formRules: {
				name: [
					{ validator: checkNameExist, trigger: 'blur' },
					{ required: true, message: '请输入规则名称', trigger: 'blur' },
					{ min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' },
				],
			},
			showDeviceInfo: false,
			defectTypes: [],
			currentJT: {
				statusInfo: {},
			},
			selectedPhase: '',
			selectedLevel: '',
			selectedDefectType: '',
			defectTypeItems: [],
			loading: false,
			clu: null,
			fileId: '',
			dialog: '',
			tableData: [],
			levels: [],
			phases: [],
			defectTypeData: [],
			cmd_parameter: '',
			showSaveDialog: false,
			showConfigDialog: false,
			editId: '',
			saving: false,
		}
	},
	watch: {
		/**
		 * 切换不同的缺陷类型时候需要过滤掉已选择的缺陷类型。
		 * @param {*} val
		 */
		selectedDefectType(val) {
			var array = this.defectTypeData.filter(t => t.phase.value == this.selectedPhase && t.level.value == this.selectedLevel)
			if (val) {
				array = this.defectTypeData.filter(t => t.phase.value == this.selectedPhase && t.level.value == this.selectedLevel && t.value == val)
			}

			this.defectTypes = array
		},
		/**
		 * 文件Id。
		 * @param {*} val
		 */
		async fileId(val) {
			if (val) {
				this.selectedPhase = 'Background'
				await this.getParams(val)
			} else {
				this.selectedPhase = ''
				this.phases = []
			}
		},
	},
	computed: {
		/**
		 * 机台Id。
		 */
		jt_id() {
			var jt_id = ''
			if (this.currentJT._id) {
				jt_id = this.currentJT._id.$oid
			}

			return jt_id
		},
		/**
		 * 缺陷类型。
		 */
		defectTypesLayout() {
			if (!this.selectedPhase || this.defectTypes.length == 0) return []

			console.log('defectTypesLayout', this.defectTypes)

			var rows = []
			var cols = []
			for (var i = 0; i < this.defectTypes.length; i++) {
				if (cols.length < 3) {
					cols.push(this.defectTypes[i])
				} else {
					rows.push(cols)
					cols = []
				}
			}

			if (cols.length > 0) {
				rows.push(cols)
			}

			return rows
		},
		/**
		 * 当前配置名称。
		 */
		currentConfigName() {
			if (this.fileId) {
				var td = this.tableData.find(t => t.file_id == this.fileId)
				if (td) {
					return td.name
				}
			}

			return '未配置（默认配置）'
		},
	},
	methods: {
		handleDialogClose1() {
			this.showSaveDialog = false
		},
		/**
		 *
		 */
		formatTooltip(val) {
			if (val == 100) {
				return '0'
			}

			return (100 - val).toString()
		},
		/**
		 *
		 * @param {*} val
		 */
		formatUnit(val) {
			return 100 - val
		},
		/**
		 * 格式化等级。
		 * @param {*} value
		 */
		getLevelStr(value) {
			value = 100 - value
			if (value == 0 || value < 5) value = 5

			return `第 ${value / 5} 级`
		},
		/**
		 * 选择缺陷类型，过滤掉当前检测等级和印次下面的缺陷类型，只保留当前选中的缺陷类型。
		 */
		filterDefectTypes() {
			var array = this.defectTypeData.filter(t => t.phase.value == this.selectedPhase && t.level.value == this.selectedLevel)

			console.log('filterDefectTypes', array)
			this.defectTypes = array
			this.defectTypeItems = array
		},
		/**
		 * 查看机台状态。
		 */
		async handleSelectJT(jtInfo) {
			this.showDeviceInfo = true
			this.currentJT = jtInfo
			console.log('this.currentJT.statusInfo', this.currentJT.statusInfo)
			this.selectedLevel = this.levelShow(this.currentJT.statusInfo.criteria_level)
			this.fileId = this.currentJT.statusInfo.criteria_level_file_id

			if (this.fileId != undefined) {
				await this.getParams(this.fileId)
			} else {
				this.phases = []
			}
		},
		/**
		 * 缺陷级别。
		 */
		levelShow(level) {
			if (level) {
				return level.charAt(level.length - 1)
			}
			return ''
		},
		/**
		 * 获取统一参数。
		 * @param {*} fileId
		 */
		async getParams(fileId) {
			this.loading = true

			var defaultCriterialContent = (await axios.get('/file/CriteriaLevel.ini')).data

			var instance = new CriteriaLevelUtil(undefined, defaultCriterialContent)
			if (!fileId) {
				this.levels = instance.getLevels()
				this.phases = instance.getPhases()
				this.defectTypeData = instance.getItems()
				this.loading = false
				this.clu = instance
				this.filterDefectTypes()
			} else {
				console.log('获取统一参数：', fileId)
				getFileContent(fileId)
					.then(res => {
						instance = new CriteriaLevelUtil(res.data, defaultCriterialContent)
					})
					.catch(err => {
						instance = new CriteriaLevelUtil(undefined, defaultCriterialContent)
						var msg = err
						if (err.toString().indexOf('404') > -1) {
							msg = '文件未找到'
						}
						this.$message.error(msg)
					})
					.finally(() => {
						this.levels = instance.getLevels()
						this.phases = instance.getPhases()
						this.defectTypeData = instance.getItems()
						this.loading = false
						this.selectedLevel = '1'

						this.clu = instance
						this.filterDefectTypes()
					})
			}
		},
		/**
		 * 保存为新配置。
		 */
		saveNew() {
			this.form = {
				id: '',
				name: '',
				fileId: '',
			}
			this.titleDialog = '配置名称'
			this.showSaveDialog = true
		},
		/**
		 * 将配置保存为文件。
		 */
		handleSave() {
			if (this.saving) return
			this.saving = true

			//获取文件内容。
			var text = this.clu.getFileBody()
			//上传统一参数文件。
			uploadFileFromContent(text, this.ruleFileName, this.form.name)
				.then(res => {
					console.log('上传结果：', res)
					this.form.name = ''
				})
				.finally(() => {
					this.showConfigDialog = false
					this.showSaveDialog = false
					this.form.name = ''
					this.loadData()
					this.saving = false
				})
		},
		/**
		 *  修改值的时候监控，修改原始数据。
		 * @param {*} item
		 * @param {*} unit
		 */
		changeValue(item, unit) {
			var index = this.defectTypeData.findIndex(t => t.phase.value == item.phase.value && t.level.value == item.level.value && t.value == item.value)
			if (index == -1) return

			unit.value = 100 - unit.reverseValue

			//更新。
			this.defectTypeData.splice(index, 1, item)
			//替换对象。
			this.clu.replaceParams(item.level.name, item.phase.value, item.value, unit.id, unit.value)
		},
		/**
		 * 选择配置。
		 */
		selectConfig() {
			this.showConfigDialog = true
		},
		/**
		 * 重置参数。
		 */
		resetConfig() {
			//使用默认统一参数实例对象，此时会加载默认配置。
			this.getParams(undefined)
		},
		/**
		 * 查看文件内容。
		 */
		handleViewContent() {},
		/**
		 * 选择参数配置。
		 * @param {*} row
		 */
		handleSelectConfig(row) {
			this.fileId = row.file_id
			this.showConfigDialog = false
		},
		/**
		 * 关闭弹窗的统一方法。
		 */
		handleDialogClose(done) {
			this.showSaveDialog = false
			this.showConfigDialog = false
			done()
		},
		/**
		 * 修改参数。
		 */
		handleModify() {
			var text = this.clu.getFileBody()
			//修改统一参数配置内容。
			updateFileFromContent(text, this.ruleFileName, this.fileId)
				.then(res => {
					this.$message({
						message: '参数修改成功',
						type: 'success',
					})
				})
				.catch(err => {
					this.$message.error('错误：' + err)
				})
		},
		/**
		 * 保存配置名称。
		 */
		SelectSave() {
			this.$refs['saveForm'].validate(valid => {
				if (valid) {
					if (this.form.id) {
						this.changeName()
					} else {
						this.handleSave()
					}
				}
			})
		},
		/**
		 * 修改配置名称。
		 */
		changeName() {
			if (this.saving) return
			this.saving = false

			EditFileFromContent(this.form.id, this.form.name)
				.then(res => {
					this.$message({
						message: '名称修改成功',
						type: 'success',
					})

					this.loadData()
				})
				.catch(err => {
					this.$message.error('错误：' + err)
				})
				.finally(() => {
					this.showSaveDialog = false
					this.form.name = ''
					this.saving = false
				})
		},
		/**
		 * 删除配置。
		 */
		handleDeleteConfig(row) {
			deleteCrieriaLevel(row._id.$oid, row.file_id)
				.then(res => {
					console.log('删除配置', res)
				})
				.finally(() => {
					this.loadData()
				})
		},
		/**
		 * 编辑配置。
		 */
		handleEditConfig(row) {
			this.titleDialog = '编辑名称'
			this.showSaveDialog = true
			this.form.id = row._id.$oid
			this.form.name = row.name
			this.form.fileId = row.file_id
		},
		/**
		 * 加载所有参数配置记录。
		 */
		loadData() {
			criteriaLevelRequest.queryAll().then(res => {
				this.tableData = res
			})
		},
		/**
		 * 下发配置。
		 */
		distribution() {
			var cmd = 1
			jtCommandRequest
				.upload({
					jt_id: this.jt_id,
					cmd: cmd,
					cmd_parameter: 'Level' + this.selectedLevel ? 'Level' + this.selectedLevel : '',
					is_set_cmd: 1,
					command_file_id: this.fileId,
					time: { $date: new Date().getTime() },
				})
				.then(res => {
					this.distribution = true
					this.$message({
						message: '命令下发成功。',
						type: 'success',
					})
				})
				.finally(() => {})
		},
	},
	created() {
		this.loadData()
	},
}
